import { render, staticRenderFns } from "./ekyc-process.vue?vue&type=template&id=4e7f7125&"
import script from "./ekyc-process.vue?vue&type=script&lang=js&"
export * from "./ekyc-process.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports